module.exports = __webpack_public_path__ + "img/logo3.62226ac3.svg";